<ng-container *ngIf="variant === 'plain'">
  <button
    *ngIf="menuTriggerFor; else plainNoMenu"
    type="button"
    [class]="computedPlainButtonClasses"
    [style.padding.px]="iconPadding || null"
    [style.--munily-icon-button-bg-opacity]="isPlainPadded ? backgroundOpacityClamped : null"
    [disabled]="disabled || loading"
    [attr.aria-label]="ariaLabel"
    [matMenuTriggerFor]="menuTriggerFor"
    (click)="onClick($event)"
  >
    <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: 'plain' }"></ng-container>
  </button>

  <ng-template #plainNoMenu>
    <button
      type="button"
      [class]="computedPlainButtonClasses"
      [style.padding.px]="iconPadding || null"
      [style.--munily-icon-button-bg-opacity]="isPlainPadded ? backgroundOpacityClamped : null"
      [disabled]="disabled || loading"
      [attr.aria-label]="ariaLabel"
      (click)="onClick($event)"
    >
      <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: 'plain' }"></ng-container>
    </button>
  </ng-template>
</ng-container>

<ng-container *ngIf="variant !== 'plain'">
  <button
    *ngIf="menuTriggerFor; else defaultNoMenu"
    mat-icon-button
    [class]="computedDefaultButtonClasses"
    [disabled]="disabled || loading"
    [attr.aria-label]="ariaLabel"
    [style.--munily-icon-button-bg-opacity]="backgroundOpacityClamped"
    [matMenuTriggerFor]="menuTriggerFor"
    (click)="onClick($event)"
  >
    <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: 'default' }"></ng-container>
  </button>

  <ng-template #defaultNoMenu>
    <button
      mat-icon-button
      [class]="computedDefaultButtonClasses"
      [disabled]="disabled || loading"
      [attr.aria-label]="ariaLabel"
      [style.--munily-icon-button-bg-opacity]="backgroundOpacityClamped"
      (click)="onClick($event)"
    >
      <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: 'default' }"></ng-container>
    </button>
  </ng-template>
</ng-container>

<ng-template #iconTpl let-mode>
  <ng-container *ngIf="!loading; else loadingIcon">
    <mat-icon *ngIf="mode === 'plain'; else defaultIcon" [ngClass]="computedPlainIconClasses">{{ icon }}</mat-icon>
    <ng-template #defaultIcon>
      <mat-icon [class]="computedDefaultIconClass">{{ icon }}</mat-icon>
    </ng-template>
  </ng-container>
  <ng-template #loadingIcon>
    <mat-icon class="material-symbols-rounded munily-icon-button__loading">progress_activity</mat-icon>
  </ng-template>
</ng-template>
